export default __webpack_public_path__ + "static/media/dental-record.83cae42b.svg";